import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions } from './filterOptions';

import { cardStyles as styles } from './index';

const InventoryReport = ({ data }) => {
  const [sellerId, setSellerId] = useState(null);
  const [soldStatus, setSoldStatus] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'inventory-report',
      params: { 'seller-id': sellerId, status: soldStatus }
    })
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Inventory Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Sold Status:</Text>
      <select style={styles.select} onChange={(e) => setSoldStatus(e.target.value)}>
        <option key="status-all">All</option>
        <option key="status-sold">Sold</option>
        <option key="status-notSold">Not Sold</option>
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default InventoryReport;
